/* eslint-disable */
import {hostAppApi} from '@/plugins/axios_settings'
import VueCookie from "vue-cookie";

export default {
  namespaced: true,
  state: {
    drawing: {project: {wpqr: [],wps: [], enabled_ndts: []},documents: []},
    weld_logs: [],
    drawings_folder_list: [],
    expertise: [],
    loading: false
  },
  getters: {
    drawings_folder_list: state => state.drawings_folder_list,
    weld_logs: state => state.weld_logs,
    drawing: state => state.drawing,
    expertise: state => state.expertise,
    loading: state => state.loading
  },
  mutations: {
    setDrawingsFolderList(state, data) {
      state.drawings_folder_list = data
    },
    setWeldLogs(state, data) {
      state.weld_logs = data;
    },
    setDrawing(state, data) {
      state.drawing = data;
    },
    setExpertise(state, data) {
      state.expertise = data;
    },
    setLoading(state, data) {
      state.loading = data;
    }
  },
  actions: {
    async getDrawingsFolderList({commit, rootGetters}, payload) {
      try {
        const hostRefApi = rootGetters.getHostRefApi
        const {data} = await hostAppApi.get(`${hostRefApi}project-drawing/${payload.project_id}/folder-list`)
        commit('setDrawingsFolderList', data)
      } catch (e) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: e.response.data.message })
      }
    },
    async getDrawing({commit, rootGetters}, payload) {
      try {
        const hostRefApi = rootGetters.getHostRefApi
        const response = await hostAppApi.get(`${hostRefApi}project-drawing/${payload.drawing_id}`, {
          params: payload
        })
        commit('setDrawing', response.data)
      } catch (e) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: e.response.data.message })
      }
    },
    async getExpertise({commit, rootGetters}, payload) {
      try {
        const hostRefApi = rootGetters.getHostRefApi
        const response = await hostAppApi.get(`${hostRefApi}expertise`, {
          params: payload
        })
        commit('setExpertise', response.data)
      } catch (e) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: e.response.data.message })
      }
    },
    async getProjectWeldLogs({commit, rootGetters}, payload) {
      try {
        commit('setLoading',true)
        const hostRefApi = rootGetters.getHostRefApi
        const response = await hostAppApi.get(`${hostRefApi}advanced-weld-log`, {
          params: payload
        })
        commit('setWeldLogs', response.data)
        commit('setLoading',false)
      } catch (e) {
        commit('setLoading',false)
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: e.response.data.message })
      }
    },
    async updateWeldLog({rootGetters},formData){
      const hostRefApi = rootGetters.getHostRefApi
      return await hostAppApi.post(`${hostRefApi}advanced-weld-log/${formData.get('id')}`, formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
  }
}
